





























































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { UserModule } from "@/store/modules/User";

interface Select {
    name: string;
    value: number | string;
}

@Component
export default class AFormField extends Vue {
    @Prop(String)
    name!: string;

    @Prop({ type: String, default: "" })
    rules!: string;

    @Prop({ type: Boolean, default: false })
    optional!: boolean;

    @Prop({ default: true })
    model!: any;

    @Prop({ default: "input" })
    typeOfInput!: string;

    @Prop({ default: null })
    helpText!: string;

    @Prop({ default: null })
    selectData!: Select;

    @Prop({ default: null })
    control!: string;

    @Prop({ default: null })
    warning!: string;

    get langCode() {
        return UserModule.settings.language;
    }
}
